import React, { useContext } from 'react';
import parse from 'html-react-parser';
import { FooterContext } from '../../../store/footer/FooterContext';
export var SiteLinksDesktop = function () {
    var _a;
    var footerContext = useContext(FooterContext);
    var data = (_a = footerContext === null || footerContext === void 0 ? void 0 : footerContext.data) === null || _a === void 0 ? void 0 : _a.siteLinksDesktopData;
    return React.createElement(React.Fragment, null, data && parse(data.marketingText));
};
